module.exports = __webpack_public_path__ + "img/image-upload.f5e82fe5.png";